import { SEO } from './SEO';

const TITLE = 'Arrived Homes | Easily invest in rental properties | Real Estate Investing Platform';
const DESCRIPTION =
  'Arrived Homes is a platform for investing in shares of rental homes starting from $100. Buy shares of rental homes, earn passive income, and let Arrived take care of the rest.';
const IMAGE = 'https://cdn.arrivedhomes.com/about/arrived_share-2.png';

/**
 * Basic SEO component for OpenGraph tags for home and landing pages.
 */
export const BasicSEO = () => (
  <SEO
    title={TITLE}
    excludeTitleEnd
    description={DESCRIPTION}
    images={[IMAGE]}
    keywords={['arrived', 'rent', 'home ownership', 'equity', 'investment']}
  />
);
